import React from "react";
import "./Home.styles.css";
import HeroSection from "./components/Herosection/Herosection";
import CustomerSupportSection from "./components/CustomerSupportSection/CustomerSupportSection";
import Testimonials from "./components/Testimonials/Testimonials";
import Teams from "./components/Testimonials/Teams";
import CTASection from "./components/CTA/CTASection";
import OurApproach from "./components/OurApproach/OurApproach";
import Team from "./components/Team/Team";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <CustomerSupportSection />
      <CTASection/>
      <OurApproach/>
      {/* <DriveGrowthSection /> */}
      {/* <FunnelAcceleration />
      <StatsSection />
      <VirtualAgents />
      <FunnelSection /> */}
      <Testimonials />
      <Teams/>
      
    </div>
  );
};

export default Home;
